import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function CausalLinkDialog({ open, onOpenChange, factors, onSubmit, preset }) {
  const [source, setSource] = useState("");
  const [target, setTarget] = useState("");
  const [justification, setJustification] = useState("");
  const locked = !!preset;

  useEffect(() => {
    if (open) {
      setSource(preset?.source || "");
      setTarget(preset?.target || "");
      setJustification("");
    }
  }, [open, preset]);

  const labelOf = (id) => (id === "INCIDENT" ? "Incident / Événement" : factors.find((f) => f.ID_FACTEUR === id)?.FACTEUR || id);

  const submit = (e) => {
    e.preventDefault();
    onSubmit({
      type_source: "FACTEUR",
      id_source: source,
      type_cible: target === "INCIDENT" ? "INCIDENT" : "FACTEUR",
      id_cible: target,
      nature_lien: "Contribue à",
      justification,
      faits_associes: [],
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="causal-link-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase">Créer un lien causal</DialogTitle>
          <DialogDescription>Précisez éventuellement le contexte de ce lien de causalité.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label>Facteur source</Label>
            {locked ? (
              <p data-testid="causal-link-source-locked" className="text-sm font-medium py-2 px-3 bg-secondary rounded-sm border border-border">{labelOf(source)}</p>
            ) : (
              <Select value={source} onValueChange={setSource}>
                <SelectTrigger data-testid="causal-link-source-select"><SelectValue placeholder="Sélectionner" /></SelectTrigger>
                <SelectContent>
                  {factors.map((f) => <SelectItem key={f.ID_FACTEUR} value={f.ID_FACTEUR}>{f.FACTEUR}</SelectItem>)}
                </SelectContent>
              </Select>
            )}
          </div>
          <p className="text-center text-xs font-mono uppercase text-muted-foreground">Contribue à →</p>
          <div>
            <Label>Facteur ou incident cible</Label>
            {locked ? (
              <p data-testid="causal-link-target-locked" className="text-sm font-medium py-2 px-3 bg-secondary rounded-sm border border-border">{labelOf(target)}</p>
            ) : (
              <Select value={target} onValueChange={setTarget}>
                <SelectTrigger data-testid="causal-link-target-select"><SelectValue placeholder="Sélectionner" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="INCIDENT">Incident / Conséquence</SelectItem>
                  {factors.filter((f) => f.ID_FACTEUR !== source).map((f) => <SelectItem key={f.ID_FACTEUR} value={f.ID_FACTEUR}>{f.FACTEUR}</SelectItem>)}
                </SelectContent>
              </Select>
            )}
          </div>
          <div>
            <Label>Justification</Label>
            <Textarea rows={3} data-testid="causal-link-justification" value={justification} onChange={(e) => setJustification(e.target.value)} />
          </div>
          <Button type="submit" disabled={!source || !target} data-testid="causal-link-submit" className="w-full bg-primary hover:bg-primary/90 text-primary-foreground">
            Créer le lien
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
